import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  textAlign: 'start',
  fontSize: '20px',
  color: '#383838',
};

export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16
};

export const sxButton: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  border: 2,
  '@media (max-width: 899px)': {
    width: 'stretch',
  }
};

export const sxButtonContained: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  '@media (max-width: 899px)': {
    width: 'stretch',
  },
};

export const sxInputAddress: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  '@media (max-width: 768px)': {
    minWidth: 'unset'
  }
}

export const sxSelect: SxProps = {
  fontFamily: 'Unimed-Sans',
  fontSize: '14px',
  fontStyle: 'normal',
  width: '100%',
  fontWeight: '400',
  svg: {color: '#383838'}
}

export const sxMenuItem: SxProps = {
  fontFamily: 'Unimed-Sans', 
  fontSize: '14px', 
  textWrap: 'pretty',
  padding: '12px', 
  margin: '0px',
}